import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContinueEditingDialogComponent } from '../dialog/continue-editing-dialog/continue-editing-dialog.component';
import { CloseDialogResult, DialogButtonRole, DialogRequestDetail } from '../models/dialog/continue-editing-dialog.model';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { DialogStateService } from './state/dialog-state.service';

@Injectable({
  providedIn: 'root',
})
export class ContinueEditingService {
  private showContinueEditingDialog: boolean = false;
  private request?: DialogRequestDetail;
  private storedUrl?: string;

  private static DIALOG_LISTENER_EVENT: string = 'showContinueEditingDialog';

  constructor(
    private readonly dialog: MatDialog,
    private readonly router: Router,
    private readonly dialogState: DialogStateService,
  ) {
    window.addEventListener(ContinueEditingService.DIALOG_LISTENER_EVENT, (event: Event) => {
      const customEvent = event as CustomEvent<DialogRequestDetail>;
      this.request = customEvent.detail;
      this.showContinueEditingDialog = !!this.request;
      this.storedUrl = '/' + (this.router.url.split('/')[1] || '');
    });
  }

  async openContinueEditingDialog(currentUrl?: string, nextUrl?: string): Promise<CloseDialogResult> {
    if (!this.showContinueEditingDialog || !this.request || !this.storedUrl || this.storedUrl === nextUrl) {
      return CloseDialogResult.disabled;
    }

    if (currentUrl && currentUrl !== this.storedUrl) {
      this.showContinueEditingDialog = false;
      this.request = undefined;
      this.storedUrl = undefined;
      return CloseDialogResult.disabled;
    }

    this.dialogState.setOpen(true);
    const dialogRef = this.dialog.open(ContinueEditingDialogComponent, {
      data: this.request,
      disableClose: this.request.disableClose === false ? this.request.disableClose : true,
      position: { top: '180px' },
      panelClass: ['ep-generic-dialog'],
    });

    const result: DialogButtonRole = await firstValueFrom(dialogRef.afterClosed());
    if (result && result !== 'primary') {
      this.showContinueEditingDialog = false;
      this.request = undefined;
      this.storedUrl = undefined;
    }

    this.dialogState.ignoreNextOutsideClick();
    this.dialogState.setOpen(false);

    return result && result === 'primary' ? CloseDialogResult.continueEditing : CloseDialogResult.cancelEditing;
  }
}
